import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
//UI-components
import { Grid } from '@mui/material';
import { TextField } from '@totalsoft/rocket-ui';

export const OfferDecisionFinancedAssetItemComponent = ({ t, asset }) => (
  <Grid container spacing={2}>
    <Grid item xs={12} sm={6} md={3}>
      <TextField disabled fullWidth value={asset.assetTypeName || ''} label={t('OfferEdit.Decision.FinancedAssets.AssetType')} />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField disabled fullWidth value={asset.assetBrand || ''} label={t('OfferEdit.Decision.FinancedAssets.Brand')} />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField disabled fullWidth value={asset.assetModel || ''} label={t('OfferEdit.Decision.FinancedAssets.Model')} />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField disabled fullWidth value={asset.quantity || ''} label={t('OfferEdit.Decision.FinancedAssets.Quantity')} />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        disabled
        fullWidth
        value={
          (asset.manufacturingYear && asset.manufacturingMonth ? asset.manufacturingMonth + '/' : ' ') +
          (asset.manufacturingYear ? asset.manufacturingYear : ' ')
        }
        label={t('OfferEdit.Decision.FinancedAssets.ManufacturingMonthAndYear')}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField disabled fullWidth value={asset.km} label={t('OfferEdit.Decision.FinancedAssets.Km')} />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        disabled
        fullWidth
        value={asset.dealerName ? asset.dealerName : ' '}
        label={t('OfferEdit.Decision.FinancedAssets.Dealer')}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        disabled
        fullWidth
        value={asset.supplierName ? asset.supplierName : ''}
        label={t('OfferEdit.Decision.FinancedAssets.Supplier')}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        disabled
        fullWidth
        isNumeric
        value={asset.acquisitionPriceWithoutVat || ''}
        label={t('OfferEdit.Decision.FinancedAssets.PriceWithoutVat')}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        disabled
        fullWidth
        isNumeric
        value={asset.acquisitionPriceWithVat || ''}
        label={t('OfferEdit.Decision.FinancedAssets.PriceWithVat')}
      />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField disabled fullWidth value={asset.currencyCode || ''} label={t('OfferEdit.Decision.FinancedAssets.Currency')} />
    </Grid>
    <Grid item xs={12} sm={6} md={3}>
      <TextField
        disabled
        fullWidth
        value={t('NUMBER', { number: asset.assetScore }) || ''}
        label={t('OfferEdit.Decision.FinancedAssets.AssetScore')}
      />
    </Grid>
  </Grid>
);

OfferDecisionFinancedAssetItemComponent.propTypes = {
  t: PropTypes.func.isRequired,
  asset: PropTypes.object
};

export default withTranslation()(OfferDecisionFinancedAssetItemComponent);
